import { DocumentSubtitleSegmentV1 } from '@utils/types/editors/subtitles/subtitle.ts';

export const getCurrentSegmentSeeking = (
  paragraphs: DocumentSubtitleSegmentV1[],
  currentTime: number
): DocumentSubtitleSegmentV1 | undefined => {
  const seekingValueInSec = currentTime ? currentTime * 1000 : 0;
  return paragraphs.find(
    paragraph =>
      paragraph.start &&
      paragraph.stop &&
      seekingValueInSec >= paragraph.start &&
      seekingValueInSec <= paragraph.stop
  );
};
